import { Pipe, PipeTransform } from '@angular/core';
import { applyExchangeRate } from '../utils/currency-exchange';

@Pipe({
  name: 'currencyExchange',
  standalone: false
})
export class CurrencyExchangePipe implements PipeTransform {
  transform(value: number, rate: number = 1) {
    return applyExchangeRate(value, rate);
  }
}
